import { useState } from 'react';
import { Form, FormInstance, FormItemProps } from 'antd';

import './index.scss';

interface FloatLabelProps extends FormItemProps {
  hasFormItem?: boolean;
  hasIcon?: boolean;
  children: any;
  label: string;
  value?: any;
  required?: boolean;
  form?: FormInstance;
  small?: string;
  float?: boolean;
  star?: boolean;
};

const FloatLabel = ({
  hasFormItem = true,
  hasIcon,
  children,
  label,
  value,
  rules = [],
  required,
  form,
  small,
  float,
  star,
  ...props
}: FloatLabelProps) => {
  const [focus, setFocus] = useState(false);

  const labelClass =
    focus || float || ((value ? value.length !== 0 : false) || (form ? !!form.getFieldValue(props.name!) : false)) ? `label label-float` : `label${hasIcon ? ' label--icon' : ''}`;
  if (hasFormItem) {
    return (
      <div
        className="float-label"
        onBlur={() => setFocus(false)}
        onFocus={() => setFocus(true)}
      >
        <Form.Item
          {... props}
          rules={required ? [...rules, { required: true, message: 'Required.' }] : rules} 
        >
          {children}
        </Form.Item>
        <label className={labelClass}>
          {label}{required || star ? <span style={{ color: 'red' }}>*</span> : null} {small ? <span style={{ fontSize: '10px' }}>{small}</span> : null}
        </label>
      </div>
    );
  }

  return (
    <div
      className="float-label"
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}
    >
      {children}
      <label className={labelClass}>{label}</label>
    </div>
  );
};

export default FloatLabel;
